"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Globe from foundation/Globe
 * @trackcomponent
 */
export const WorldGlobe = createSVGIcon(
  <>
    <path
      d="M8 0C6.41775 0 4.87104 0.469192 3.55544 1.34824C2.23985 2.2273 1.21447 3.47673 0.608967 4.93853C0.00346627 6.40034 -0.15496 8.00888 0.153721 9.56073C0.462403 11.1126 1.22433 12.538 2.34315 13.6569C3.46197 14.7757 4.88743 15.5376 6.43928 15.8463C7.99113 16.155 9.59966 15.9965 11.0615 15.391C12.5233 14.7855 13.7727 13.7602 14.6518 12.4446C15.5308 11.129 16 9.58226 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08602 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0ZM13.544 4.8H11.668C11.4819 3.90724 11.18 3.04259 10.77 2.228C11.9317 2.78779 12.8982 3.68391 13.544 4.8ZM6.6 3.058C7.102 2.058 7.64 1.6 8 1.6C8.36 1.6 8.896 2.054 9.4 3.058C9.66961 3.61472 9.8788 4.19872 10.024 4.8H5.976C6.12087 4.19862 6.33007 3.61458 6.6 3.058ZM1.8 9.6C1.53069 8.55034 1.53069 7.44967 1.8 6.4H4.08C3.972 7.46394 3.972 8.53607 4.08 9.6H1.8ZM2.454 11.2H4.33C4.51611 12.0928 4.818 12.9574 5.228 13.772C4.0671 13.2119 3.10132 12.3158 2.456 11.2H2.454ZM4.33 4.8H2.456C3.10185 3.68391 4.06836 2.78779 5.23 2.228C4.82 3.04259 4.51811 3.90724 4.332 4.8H4.33ZM9.4 12.942C8.898 13.942 8.36 14.4 8 14.4C7.64 14.4 7.104 13.946 6.6 12.942C6.33007 12.3854 6.12087 11.8014 5.976 11.2H10.024C9.87914 11.8014 9.66993 12.3854 9.4 12.942ZM10.31 9.6H5.69C5.62922 9.06885 5.59917 8.53463 5.6 8C5.60002 7.46541 5.63007 6.93123 5.69 6.4H10.31C10.43 7.4633 10.43 8.53671 10.31 9.6ZM10.77 13.772C11.18 12.9574 11.4819 12.0928 11.668 11.2H13.544C12.8982 12.3161 11.9317 13.2122 10.77 13.772ZM14.4 8C14.4011 8.53964 14.3339 9.07724 14.2 9.6H11.92C12.028 8.53607 12.028 7.46394 11.92 6.4H14.2C14.3339 6.92277 14.4011 7.46037 14.4 8Z"
      fill="currentColor"
    />
  </>,
  "World Globe",
  {
    viewBox: "0 0 16 16",
    titleAccess: "World Globe",
    fill: "none",
  }
);
